/**
 * @author zy
 * 2020-04-30
 * 查看问卷图表插件
 *
 */
import React from 'react'
import { connect } from 'dva'
import { modelUtils } from '../../../../../utils'
import ResultPercent from './resultPercent'
import { component_tool, framework_tool } from '@/tool'
import logger from "less/lib/less/logger";
let {
  WizCard,
} = component_tool;
let { WizContainer } = framework_tool;

class SurveyResultCharts extends WizContainer {

  componentName = 'SurveyResultCharts';

  constructor(props) {
    super(props);
  }

  _componentDidMount() {
    //this._getData()
  }

  _getData(other = {}) {
    this.doAction({
      path: `classStudentSurvey/queryClassStudentSurveySummary`,
      payload: {
        key: `classStudentSurvey@queryClassStudentSurveySummary`,
        apiParams: { classInfoId: this.props.classInfoId, surveyId: this.props.surveyId }
      }
    });
  };

  state = {
  };

  propsAndStateOnChange = {
    classStudentSurveyInfo: this._getClassStudentExamInfoOver.bind(this)
  }

  _getClassStudentExamInfoOver(nextProps, nextState) {
    let data = [];
    if (nextProps.classStudentSurveyInfo.code === 1) {
      data = nextProps.classStudentSurveyInfo.data;
      this.chartsData = data;
      return data;
    } else {
      wizNotice.error('图表数据获取失败！！');
      return false;
    }
  }

  _render() {
    let titles = ['问卷名称', '问卷时间'];
    let values = this.chartsData ? [this.chartsData.surveyName, (this.chartsData.startDate + ' ～ ' + this.chartsData.endDate)] : ['', ''];
    let resultPrecent = this.chartsData ? <ResultPercent key={new Date().getTime() + '_classResultPercent'}
      headerProps={{ title: titles, value: values }}
      percentProps={{
        data: [
          {
            item: "参加人数",
            count: this.chartsData.joinCount < 0 ? 0 : this.chartsData.joinCount,
          },
          {
            item: "未参加人数",
            count: this.chartsData.noJoinCount < 0 ? 0 : this.chartsData.noJoinCount,
          },
        ],
        dataFormat: {
          type: "percent",
          field: "count",
          dimension: "item",
          as: "percent"
        },
        count: this.chartsData.totalCount && this.chartsData.totalCount,
        centerText: '总人数'
      }}
    // itemProps={[
    //   { img: constants.files.sys_exam_precent_max, title: '最高分', value: this.chartsData.maxScore + '分' },
    //   { img: constants.files.sys_exam_precent_avg, title: '平均分', value: this.chartsData.avgScore + '分' },
    //   { img: constants.files.sys_exam_precent_min, title: '最低分', value: this.chartsData.minScore + '分' }
    // ]}
    /> : null;

    return [
      <WizCard title={'问卷概况'} key={new Date().getTime()} bodyStyle={{ paddingLeft: 20, paddingBottom: 0, paddingTop: 15 }}>
        {resultPrecent}
      </WizCard>
    ]
  }
}

const mapStateToProps = (state, ownProps) => {
  const { classStudentSurvey } = state;
  const classStudentSurveyInfo = modelUtils.getModelEntity(classStudentSurvey, "classStudentSurvey@queryClassStudentSurveySummary");
  return {
    classStudentSurveyInfo: classStudentSurveyInfo,
  };
};

export default connect(mapStateToProps)(SurveyResultCharts);
